// Static content for Inter Club Guardialfiera. Edit here to update news, trips, gallery, etc.

export const CLUB = {
  logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_clubgdaifiera/artifacts/ic1ve2eo_LOGO%20INTER%20CLUB.png",
  name: "Inter Club Guardialfiera",
  tagline: "La passione nerazzurra nel cuore del Molise",
  town: "Guardialfiera (CB)",
  founded: "2026",
  email: "interclub.guardialfiera@gmail.com",
  phone: "",
  address: "Via Dante Alighieri, 23 — 86030 Guardialfiera (CB)",
  whatsapp: "https://wa.me/393200000000",
  instagram: "https://www.instagram.com/interclubguardialfiera/",
  facebook: "https://www.facebook.com/interguardialfiera",
};

export const STATS = [
  { value: "123", suffix: "", label: "Soci Iscritti", icon: "Users" },
  { value: "1", suffix: "", label: "Trasferte a San Siro", icon: "Bus" },
  { value: "1908", suffix: "", label: "Orgoglio Nerazzurro", icon: "Star" },
  { value: "100", suffix: "%", label: "Cuore Interista", icon: "Heart" },
];

export const TIERS = [
  {
    id: "senior-kit",
    name: "Socio Senior",
    kit: "con Welcome Kit",
    price: 45,
    popular: true,
    perks: ["Tessera ufficiale Inter Club", "Welcome Kit stagione 26/27", "Priorità sui viaggi in pullman", "Sconti Inter Store & Museo San Siro"],
  },
  {
    id: "senior",
    name: "Socio Senior",
    kit: "senza Kit",
    price: 40,
    popular: false,
    perks: ["Tessera ufficiale Inter Club", "Priorità sui viaggi in pullman", "Sconti convenzioni locali", "Inviti agli eventi del club"],
  },
  {
    id: "junior",
    name: "Socio Junior",
    kit: "nati dal 01/08/2012",
    price: 25,
    popular: false,
    perks: ["Tessera ufficiale Inter Club", "Welcome Kit Junior", "Attività dedicate ai più piccoli", "Sconti sui viaggi organizzati"],
  },
];

export const TRIPS = [
  { id: "t1", opponent: "Inter vs Parma", competition: "Serie A", date: "10 OTT 2026", time: "18:00", departure: "Guardialfiera • Milano", seats: 8, total: 50 },
];

export const NEWS = [
  {
    id: "n1",
    category: "Il Club",
    date: "12 Giugno 2026",
    title: "Aperto il tesseramento stagione 2026/2027",
    excerpt: "Da oggi è possibile rinnovare o sottoscrivere la tessera dell'Inter Club Guardialfiera. Tante novità nel Welcome Kit di quest'anno.",
    image: "https://images.unsplash.com/photo-1686853853302-0ce5b768f30f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    featured: true,
  },
  {
    id: "n2",
    category: "Trasferte",
    date: "28 Maggio 2026",
    title: "Pullman per Inter-Juventus: prenotazioni aperte",
    excerpt: "Organizziamo il viaggio in pullman verso San Siro per il big match. Posti limitati, prenota il tuo.",
    image: "https://images.unsplash.com/photo-1655587044257-023d0b32cd9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    featured: false,
  },
  {
    id: "n3",
    category: "Eventi",
    date: "15 Maggio 2026",
    title: "Cena sociale di fine stagione al circolo",
    excerpt: "Una serata insieme per festeggiare la stagione nerazzurra. Vi aspettiamo numerosi presso la sede del club.",
    image: "https://images.unsplash.com/photo-1693517413656-d3445182b2e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    featured: false,
  },
  {
    id: "n4",
    category: "Mondo Inter",
    date: "02 Maggio 2026",
    title: "Le pagelle nerazzurre della stagione",
    excerpt: "Il commento dei nostri soci sui protagonisti dell'annata. Chi è stato il migliore in campo?",
    image: "https://images.unsplash.com/photo-1782472003016-0a22e37bbf9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    featured: false,
  },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1686853853302-0ce5b768f30f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Coreografia nerazzurra" },
  { src: "https://images.unsplash.com/photo-1782472003016-0a22e37bbf9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "San Siro sotto le luci" },
  { src: "https://images.unsplash.com/photo-1693517413656-d3445182b2e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Il secondo anello" },
  { src: "https://images.unsplash.com/photo-1693517382976-20ef824a9c7c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Curva Nord in festa" },
  { src: "https://images.pexels.com/photos/10785346/pexels-photo-10785346.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Il Meazza dall'esterno" },
  { src: "https://images.unsplash.com/photo-1782471693041-feb890827bc3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Serata di Champions" },
  { src: "https://images.unsplash.com/photo-1655587044257-023d0b32cd9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "In trasferta con il club" },
  { src: "https://images.pexels.com/photos/7492382/pexels-photo-7492382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Cattedrale del calcio" },
];

export const SPONSORS = ["Il Casale di Clesilde"];

// Dati per il bonifico bancario (quota iscrizione)
export const BANK = {
  intestatario: "Katia Di Vito",
  banca: "HYPE",
  iban: "IT35N03268223000EM002672446",
};

// Avatar segnaposto direttivo (stile nerazzurro)
export const AVATARS = {
  uomo: "https://static.prod-images.emergentagent.com/jobs/00731df9-c37b-47b2-b81b-bfd5104f919f/images/81fe7695990fcd5de520677bf41a5cb29f47d721f25be3512bfc2db45812898b.jpeg",
  donna: "https://static.prod-images.emergentagent.com/jobs/00731df9-c37b-47b2-b81b-bfd5104f919f/images/63080d11724a1a9ddf79352e6e81859a3dce932cc59936938a8530a9745d0f7f.jpeg",
};

// Direttivo del club — aggiorna nomi, ruoli, genere (uomo/donna) o metti una foto in "foto"
export const DIRETTIVO = [
  { nome: "Gaudenzio Spugnardi", ruolo: "Presidente", genere: "uomo", foto: "" },
  { nome: "Michelangelo Pistilli", ruolo: "Vice Presidente", genere: "uomo", foto: "" },
  { nome: "Luigi Tarchino", ruolo: "Segretario", genere: "uomo", foto: "" },
  { nome: "Katia Di Vito", ruolo: "Tesoriere", genere: "donna", foto: "" },
  { nome: "Mario Pomponio", ruolo: "Referente IT", genere: "uomo", foto: "" },
  { nome: "Monia Antenucci", ruolo: "Consigliere", genere: "donna", foto: "" },
  { nome: "Davide Madonna", ruolo: "Consigliere", genere: "uomo", foto: "" },
  { nome: "Tommaso Sticca", ruolo: "Consigliere", genere: "uomo", foto: "" },
  { nome: "Benni Pilla", ruolo: "Consigliere", genere: "uomo", foto: "" },
];
